import { TransitionProps } from "@mui/material/transitions";
import { Slide } from "@mui/material";
import { forwardRef } from "react";

/**
 * This React component can be used as `TransitionComponent` in a mui `Dialog`.
 */
export const SlideUp = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
